export const formatTimestamp = (timestamp: number, full = false): string => {
  if (!timestamp) {
    return ''
  }
  const date = new Date(timestamp * 1000)
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  // const seconds = date.getSeconds()

  return (
    `${day}-${month}-${year}` +
    (full
      ? ` ${hours < 10 ? '0' + hours : hours}:${
          minutes < 10 ? '0' + minutes : minutes
        }`
      : '')
  )
}

export const reorderArray = <T>(
  array: Array<T>,
  oldIndex: number,
  newIndex: number
): Array<T> => {
  const returnArray = [...array]
  returnArray.splice(newIndex, 0, returnArray.splice(oldIndex, 1)[0])
  return returnArray
}
interface Orderable {
  order: number | null
}
export const sortByOrder = <T extends Orderable>(array: Array<T>): Array<T> =>
  [...array].sort((a: T, b: T) => {
    if (b.order === null) {
      return -1
    }
    if (a.order === null) {
      return 1
    }

    return a.order < b.order ? -1 : 1
  })

interface Identifiable {
  id: string
}

export const updateIdentifiableList = <T extends Identifiable>(
  aList: Array<T>,
  anElement: T
): Array<T> =>
  aList.map((el: T): T => (el.id === anElement.id ? anElement : el))

export const pagination = {
  pages: [10, 15, 25, 50, 100, 150, 250],
  default: 15,
}
